import z from "zod";
import UsersService from "../../../../services/UserService";
import { UserRole, UserStatus } from "../../../../enums";
import { mapErrorsToFields } from "../../../../utils";

const api = new UsersService();
export async function deleteUser(id: string) {
  try {
    await api.deleteUser(id);
  } catch (error) {
    console.error("Database Error:", error);
    // Handle error appropriately, e.g., return an error message
  }
}

export type State = {
  errors?: {
    name?: string[];
    phone?: string[];
    status?: string[];
    role?: string[];    
    general?: string[];
  };
  
  defaultValues: {
    name?: string;
    phone?: string;
    status: string;
    role: string;    
  };
  message?: string | null;
  success?: boolean;
};

export async function updateUser(
  id: string,
  fprevState: State,
  formData: FormData
): Promise<State> {

  const FormSchema = z.object({
    name: z.string().min(1, { message: "Name is required." }),
    phone: z.string().min(1, { message: "Phone is required." }),
    status: z.nativeEnum(UserStatus, {
      error: "Invalid user status.",
    }),
    role: z.nativeEnum(UserRole, {
      error: "Invalid user role.",
    })
    
  });

  const validatedFields = FormSchema.safeParse({
    name: formData.get("name"),
    phone: formData.get("phone"),
    status: formData.get("status"),
    role: formData.get("role"),
    
  });

  const defaultValues = {
    name: formData.get("name")?.toString() || "",
    phone: formData.get("phone")?.toString() || "",
    status: formData.get("status")?.toString() || "",
    role: formData.get("role")?.toString() || "",
    
  };

  if (!validatedFields.success) {
    return {
      errors: mapErrorsToFields( validatedFields.error),
      message: "Failed to update user.",
      defaultValues,
      success: false,
    };
  }

  const { name, phone, status, role } = validatedFields.data;
  // check if email already exists for another user
  try {
    const result = await api.updateUser(id, {
      name,
      phone,
      status,
      role,      
    });
        
    if (result.status === 200) { 
      return {
        message: "User updated successfully.",
        success: true,
        defaultValues:defaultValues,
        errors: {},
      };
    }

  } catch (error) {
    console.error("Database Error:", error);
    // Handle error appropriately, e.g., return an error message
    return {
        errors: { },
        message: "Failed to update user.",
        defaultValues:defaultValues,
        success: false,
      };
  }

  return {
    errors: { },
    message: "Failed to update user.",
    defaultValues,
    success: false,
  };
}
